import type { MenuTypeSlug } from './menuTypes.js';
import type { CourseSlug } from './courses.js';

/**
 * Per-menu course display labels (course slug → heading text).
 * `null` means the course is rendered WITHOUT a heading (the Menu du Jour
 * prints headingless, per spec). Ported from HOTEL_MENU_COURSE_LABELS in
 * menu-helpers.php.
 */
export const COURSE_LABELS: Record<MenuTypeSlug, Partial<Record<CourseSlug, string | null>>> = {
  daily: {
    entree: null,
    'plat-principal': null,
    dessert: null,
  },
  formule: {
    entree: 'Entrées',
    'plat-principal': 'Plats',
    dessert: 'Desserts',
  },
  carte: {
    entree: 'Les Entrées',
    'plat-principal': 'Les Plats',
    tartiflette: 'Tartiflettes',
    pates: 'Les Pâtes',
    fromages: 'Fromages',
    dessert: 'Les Desserts',
  },
};
